import Button from '../../../../../../components/Button';
import ButtonModel from '../../../../../../components/Button/enums/ButtonModel.enum';
import { Plus } from '../../../../../../assets/icons/plus';
import React from 'react';
import { useKioskLiveUsageContext } from '../contexts/KioskLiveUsageContext';
import { useLoadReservationOnKioskModalContext } from '../contexts/LoadReservationOnKioskModalContext';

export const LoadReservationButton: React.FC = () => {
  const { openModal: openLoadReservationModal } = useLoadReservationOnKioskModalContext();
  const {
    featureFlag: { isLoading: isLoadingFeatureFlag, isEnabled },
  } = useKioskLiveUsageContext();

  return (
    <Button
      model={ButtonModel.QUICK_ACTION_MODAL_CONFIRM}
      onClick={openLoadReservationModal}
      bold
      style={{ gap: '5px' }}
      disabled={isLoadingFeatureFlag || !isEnabled}
    >
      <Plus />
      Load Reservation for Check-in
    </Button>
  );
};
